import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../../theme";

const Card = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
  background: linear-gradient(
    160deg,
    ${theme.colors.text.quaternary} 0%,
    rgba(255, 255, 255, 0.015) 100%
  );
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 18px;
  padding: 20px;
  overflow: hidden;
  cursor: pointer;
  transition:
    border-color 0.35s ease,
    background 0.35s ease;
  will-change: transform;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    height: 2px;
    background: ${theme.colors.primary};
    border-radius: 2px 2px 0 0;
    transform: scaleX(0);
    transform-origin: left center;
    transition: transform 0.35s cubic-bezier(0.23, 1, 0.32, 1);
  }

  &:hover {
    border-color: ${theme.colors.primary}66;
    background: linear-gradient(
      160deg,
      ${theme.colors.text.quaternary} 0%,
      ${theme.colors.primary}08 100%
    );

    &::after {
      transform: scaleX(1);
    }

    p:first-of-type {
      color: ${theme.colors.primary};
    }

    [data-icon] {
      background: ${theme.colors.primary}20;
      border-color: ${theme.colors.primary}55;
    }

    [data-icon] svg {
      opacity: 1;
    }
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const IconWrapper = styled(motion.div)`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: ${theme.colors.primary}12;
  border: 1px solid ${theme.colors.primary}22;
  transition:
    background 0.3s ease,
    border-color 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
    color: ${theme.colors.primary};
    opacity: 0.75;
    transition: opacity 0.3s ease;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Title = styled.p`
  color: ${theme.colors.text.primary};
  font-family: "DM Sans", "Inter", sans-serif;
  font-size: 1rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.35;
  margin: 0;
  transition: color 0.25s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Description = styled.p`
  color: ${theme.colors.text.secondary};
  font-family: "DM Sans", "Inter", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  opacity: 0.55;
`;

const SC = {
  Card,
  Row,
  IconWrapper,
  Content,
  Title,
  Description,
};

export default SC;
